<template>
  <div class="base">
    <main-header page_type="tutor_list" />
    <div class="main">
      <van-search v-model="filterCondition.teacher_id" shape="round" placeholder="请输入教员编号" @search="onSearchTeacher" />
      <!-- <div class="search-area">
                <a-input class="search" placeholder="请输入教师编号">
                    <a-icon slot="prefix" type="search" />
                </a-input>
            </div> -->
      <div class="filter-conditions">
        <van-dropdown-menu>
          <van-dropdown-item v-model="areaSelect" :options="areaOptions" @change="areaChange" />
          <van-dropdown-item v-model="weekDaySelect" :options="weekDayOptions" @change="weekDayChange" />
          <van-dropdown-item v-model="categorySelect" :options="categoryOptions" @change="categoryChange" />
          <van-dropdown-item v-model="courseSelect" :options="courseOptions" :disabled="courseDisabled"
            @change="courseChange" />
        </van-dropdown-menu>
      </div>
      <div class="instructor">
        <a-skeleton :loading="loading" />
        <a-empty v-if="pack_list.length == 0 && !loading" />
        <div class="list">
          <div v-for="item in pack_list.data" :key="item.id" class="item" :v-if="pack_list.length > 0">
            <a-row :gutter="16">
              <a-col :span="6" class="teacher-info-area">
                <div class="header-img">
                  <img v-show="item.teacher_info.avatar" :src="item.teacher_info.avatar" alt="头像"
                    @click="goTeacherShow(item.teacher_info.id)">
                  <img v-show="!item.teacher_info.avatar" src="@/assets/test-header.png" alt="">
                </div>
                <div class="name">
                  {{ item.teacher_info.nick_name }}
                </div>
                <div class="code">
                  T{{ item.teacher_info.id }}
                </div>
              </a-col>
              <a-col :span="18" class="pack-info">
                <div class="title" @click="goPackInfo(item.id)">
                  {{ item.title }}
                </div>
                <div class="desc">
                  {{ item.desc }}
                </div>
                <div class="rate-price">
                  <div class="rate">
                    <a-rate :value="item.star" style="font-size: 12px;color:coral" />
                  </div>
                  <div class="price">
                    <span class="prefix">￥</span>
                    <span class="money">{{ item.price }}</span>
                    <span class="suffix">/小时</span>
                  </div>
                </div>
              </a-col>
            </a-row>
          </div>
        </div>
      </div>
      <div class="pagination">
        <van-pagination v-if="pack_list.length > 0" v-model="current_page" :total-items="total_page" :show-page-size="3"
          force-ellipses @change="pageChange" />
      </div>
    </div>
    <main-footer />
  </div>
</template>
<script>
import { MainHeader, MainFooter } from '@/components'
import store from '@/store/'

export default {
  name: 'TutorList',
  description: '选课',
  components: {
    MainHeader,
    MainFooter
  },
  props: {
    page: {},
    week_day: {},
    area: {},
    category: {},
    course: {}
  },
  // 初始化变量
  data() {
    return {
      loading: true,
      filterCondition: {
        week_day: 'all',
        area: 'all',
        category: 'all',
        course: 'all',
        teacher_id: null
      },
      pack_list: {}, // 列表数据
      region_area: [], // 区域列表
      region_university: [], // 大学列表
      course_cate: [], // 课程分类
      areaSelect: 'all',
      //   areaOptions: [], 计算属性
      weekDaySelect: 'all',
      weekDayOptions: [
        { text: '全部日期', value: 'all' },
        { text: '周六', value: '周六' },
        { text: '周一', value: '周一' },
        { text: '周二', value: '周二' },
        { text: '周三', value: '周三' },
        { text: '周四', value: '周四' },
        { text: '周五', value: '周五' }
      ],
      categorySelect: 'all',
      //   categoryOptions: [],
      courseSelect: 'all',
      courseOptions: [],
      courseDisabled: false,
      total_page: '',
      current_page: 1,
      last_page: 1
    }
  },
  computed: {
    region: function () {
      return store.getters.region
    },
    areaOptions: function () {
      // 将地区数据处理成组件可用的样子
      var data = [
        {
          text: '全部地区',
          value: 'all'
        }
      ]
      this.region_area.forEach(function (item) {
        data.push({
          text: item.name,
          value: item.name
        })
      })
      return data
    },
    categoryOptions: function () {
      var data = [
        {
          text: '全部年级',
          value: 'all'
        }
      ]
      this.course_cate.forEach(function (item) {
        data.push({
          text: item.title,
          value: item.title
        })
      })
      return data
    }
  },
  watch: {
    // url改变，重新加载数据
    $route() {
      this.loadData(this.page)
    },
    week_day(val) {
      this.filterCondition.week_day = val
    },
    area(val) {
      console.log(val)
      this.filterCondition.area = val
    },
    category(val) {
      this.filterCondition.category = val
    },
    course(val) {
      this.filterCondition.course = val
    },
    pack_list(val) {
      this.current_page = val.current_page
      this.total_page = val.total_page
      this.last_page = val.last_page
    },
    course_cate(courseCate) {
      var category = this.filterCondition.category
      if (category === 'all') {
        this.courseOptions = [
          {
            text: '全部科目',
            value: 'all'
          }
        ]
        this.courseDisabled = true
      } else {
        var courseList = []
        for (var i = 0; i < courseCate.length; i++) {
          if (courseCate[i].title === category) {
            courseList = courseCate[i].course_list
            break
          }
        }
        var data = [
          {
            text: '全部科目',
            value: 'all'
          }
        ]
        courseList.forEach(function (item) {
          data.push({
            text: item.title,
            value: item.title
          })
        })
        this.courseOptions = data
        this.courseDisabled = false
      }
    }
  },
  created() {
    this.loadData(this.page)
  },
  mounted() {
    if (this.area !== undefined) {
      this.filterCondition.area = this.area
      this.areaSelect = this.area
    }
    if (this.week_day !== undefined) {
      this.filterCondition.week_day = this.week_day
      this.weekDaySelect = this.week_day
    }
    if (this.category !== undefined) {
      this.filterCondition.category = this.category
      this.categorySelect = this.category
    }
    if (this.course !== undefined) {
      this.filterCondition.course = this.course
      this.courseDisabled = false
      this.courseSelect = this.course
      console.log(this.course)
    }
  },
  methods: {
    loadData(page) {
      this.loading = true
      var queryParam = {}
      queryParam.region = this.region
      const filterCondition = this.filterCondition
      if (filterCondition.week_day !== 'all') {
        queryParam.week_day = filterCondition.week_day
      }
      if (filterCondition.area !== 'all') {
        queryParam.area = filterCondition.area
      }
      if (
        filterCondition.category !== 'all' &&
        filterCondition.course !== 'all'
      ) {
        queryParam.teaching_subject =
          filterCondition.category + filterCondition.course
      }
      if (filterCondition.teacher_id !== null) {
        queryParam.teacher_id = filterCondition.teacher_id
      }

      if (page) {
        queryParam.page = page
      }

      this.$http({
        url: '/index/index/findTutor',
        method: 'get',
        params: queryParam
      }).then(res => {
        if (res.status === 'success') {
          this.loading = false
          const data = res.data
          console.log(data)
          this.pack_list = data.pack_list
          this.region_area = data.region_area
          this.region_university = data.region_university
          // 课程分类
          this.course_cate = data.course_cate
        } else {
          this.$notification.error({
            message: '系统繁忙，请刷新重试',
            description: ''
          })
        }
      })
    },
    areaChange(value) {
      this.filterCondition.area = value
      this.$router.push({ name: 'TutorList', query: this.filterCondition })
    },
    weekDayChange(value) {
      this.filterCondition.week_day = value
      this.$router.push({ name: 'TutorList', query: this.filterCondition })
    },
    categoryChange(value) {
      this.filterCondition.category = value
      this.$router.push({ name: 'TutorList', query: this.filterCondition })
    },
    courseChange(value) {
      this.filterCondition.course = value
      this.$router.push({ name: 'TutorList', query: this.filterCondition })
    },
    onSearchTeacher(value) {
      this.filterCondition.teacher_id = value
      this.$router.push({ name: 'TutorList', query: this.filterCondition })
    },
    pageChange(value) {
      this.filterCondition.page = value
      this.$router.push({ name: 'TutorList', query: this.filterCondition })
    },
    goTeacherShow(teacherId) {
      this.$router.push({ name: 'RevealInfo', params: { id: teacherId } })
    },
    goPackInfo(packId) {
      this.$router.push({ name: 'TutorInfo', params: { id: packId } })
    }
  }
}
</script>
<style lang="stylus" scoped>

.main {
    padding: 0px 15px 15px 15px;
}

.search-area {
    .search {
        input {
            background-color: #f5f5f5;
            border-radius: 10px;
        }
    }
}

.filter-conditions {
    .van-dropdown-menu__bar {
        box-shadow: none;
    }
}

.instructor {
    margin-top: 20px;
    min-height: 300px;

    .list {
        .item {
            padding:15px;
            margin-bottom: 15px;
            box-shadow: 0 0 10px 0 rgba(216,216,216,0.3);

            .teacher-info-area {
                text-align: center;

                .header-img {
                    img {
                        width: 60px;
                        height: 60px;
                        border-radius: 50%;
                    }
                }

                .name {
                    font-family: PingFang-SC-Medium;
                    font-size: 12px;
                    line-height: 16px;
                    color: #333333;
                    margin-top: 10px;
                }

                .code {
                    font-family: PingFang-SC-Regular;
                    font-size: 11px;
                    line-height: 18px;
                    color: #999999;
                }

            }

            .pack-info {
                .title {
                    font-family: PingFang-SC-Medium;
                    font-size: 15px;
                    line-height: 16px;
                    color: #ff5c00;
                }

                .desc {
                    margin-top: 13px;
                    font-family: PingFang-SC-Regular;
                    font-size: 14px;
                    line-height: 16px;
                    color: #666666;
                }

                .rate-price {
                    margin-top: 15px;
                    overflow: hidden;

                    .rate {
                        float: left;
                    }

                    .price {
                        float: right;

                        .prefix {
                            font-family: PingFang-SC-Medium;
                            font-size: 10px;
                            line-height: 18px;
                            color: #999999;
                        }

                        .money {
                            font-family: PingFang-SC-Medium;
                            font-size: 18px;
                            color: #ff5c00;
                        }

                        .suffix {
                            font-family: PingFang-SC-Medium;
                            font-size: 10px;
                            line-height: 18px;
                            color: #999999;
                        }
                    }
                }
            }
        }
    }
}
</style>
